import articleSystemToEditMode from './articleSystemToEditMode';
import editModeToArticleSystem from './editModeToArticleSystem';
import getPayloadWithCreatedText from './getPayloadWithCreatedText';

export default {
  articleSystemToEditMode,
  editModeToArticleSystem,
  getPayloadWithCreatedText,
};
